import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ApiModule } from '../api.module';
import { CrudApiService } from '../../../core/service/abstract/rest-api.service';
import { User } from '../../../data/model/user';
import { ENV_CONFIG, EnvironmentConfig } from '../../../core/enviroment-config';

@Injectable({
  providedIn: ApiModule
})
export class PasswordResetApiService extends CrudApiService<User> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('rest-auth/password/change/', http, config);
  }
}

